import camelCase from 'next/dist/build/webpack/loaders/css-loader/src/camelcase';

export const camelizeKeys = (obj: unknown): unknown => {
	if (Array.isArray(obj)) {
		return obj.map((v) => camelizeKeys(v));
	} else if (obj && obj?.constructor === Object) {
		return Object.keys(obj).reduce((result, key) => {
			const camelKey = camelCase(key);
			// @ts-ignore
			result[camelKey] = camelizeKeys(obj[key]);
			return result;
		}, {} as Record<string, unknown>);
	}
	return obj;
};
